export const environment = {
  production: true,
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US'],
  serverProtocol: "https://",
  serverDomain: "app.policym8.com"
};
